import ImagesFactory from '../../../factory/images';
import { updateVideoPlayerSize } from '../../../video';
import VideoGetter from '../getters/video';

import ElementSetter from './abstract/element';

module.exports = VideoSetter;

function VideoSetter () {
  this.handledAttributes = _.union([
    'autoplay',
    'controls',
    'clip_path',
    'duration',
    'fullscreen',
    'height',
    'loop',
    'movetonext',
    'mute',
    'source',
    'thumb_src',
    'url',
    'width',
    'x',
    'y'
  ], this.handledAttributes);
}

VideoSetter.prototype = new ElementSetter();
VideoSetter.prototype.constructor = VideoSetter;

VideoSetter.prototype.updateAutoplay = function (element, data) {
  $(element).toggleClass('autoplay', data.autoplay);
};

VideoSetter.prototype.updateMovetonext = function (element, data) {
  $(element).toggleClass('movetonext', data.movetonext);
};

VideoSetter.prototype.updateControls = function (element, data) {
  $(element).toggleClass('controls', data.controls);
};

VideoSetter.prototype.updateFullscreen = function (element, data) {
  $(element).toggleClass('fullscreen', data.fullscreen);
};

VideoSetter.prototype.updateLoop = function (element, data) {
  $(element).toggleClass('loop', data.loop);
};

VideoSetter.prototype.updateMute = function (element, data) {
  $(element).toggleClass('mute', data.mute);
};

VideoSetter.prototype.updateThumbSrc = function (element, data) {
  if (!data.source) {
    const image = $(element).children('image')[0];

    svgedit.utilities.assignAttributes(image, {
      'xlink:href': data.thumb_src,
      style: {
        objectFit: 'contain',
        width: data.width
      }
    }, 100);
    this._smartImageLoad(element, data);
    this.trigger('thumb_src', element.getAttribute('id'), data);
  }
};

VideoSetter.prototype.updateSource = function (element, data) {
  const youtubeSource = this._getYoutubeCode(data.source);
  data.source = youtubeSource || data.source;
  data.thumb_src = youtubeSource ? 'http://img.youtube.com/vi/' + data.source + '/mqdefault.jpg' : (data.thumbnail || data.thumb_src);
  const isExternalThumbnail = !ImagesFactory.isAmazonImage(data.thumb_src);
  const href = youtubeSource
    ? 'https://www.youtube.com/watch?v=' + data.source
    : data.file || data.source;

  svgedit.utilities.assignAttributes(element, {
    'xlink:href': href,
    'data-video-type': youtubeSource ? 'youtube' : 'mp4'
  }, 100);

  isExternalThumbnail && this._resizeExternalThumbnail(element, data);
  isExternalThumbnail || this._smartImageLoad(element, data);

  this.trigger('source', element.getAttribute('id'), data);
};

VideoSetter.prototype._smartImageLoad = function (element, data) {
  const image = element.tagName === 'image'
    ? element
    : element.querySelector('image');
  const size = svgedit.utilities.getBBox(image);

  this.trigger('optimize_resolution', element.getAttribute('id'));
  ImagesFactory.smartLoad(data.thumb_src, size, (status, optimusImage) => {
    const canUpdateImage = status === INKIVE.C.Status.success || data.thumb_src;
    data.thumb_src = status === INKIVE.C.Status.success
      ? optimusImage.src
      : data.thumb_src;

    if (canUpdateImage) {
      image && image.setAttribute('xlink:href', data.thumb_src);
      updateImageDimensions(element, image, optimusImage);
      this.trigger('resolution_optimized', element.getAttribute('id'), data);
    }
  });

  function updateImageDimensions (element, image, replaceImage) {
    const dimensions = getNewDimensions(element, replaceImage);
    const elements = [
      image,
      element.querySelector('foreignObject'),
      element.querySelector('video')
    ];

    elements.filter(Boolean)
      .forEach(target => svgedit.utilities.assignAttributes(target, dimensions));
  }

  function getNewDimensions (element, replaceImage) {
    const clipPath = svgedit.utilities.getClipPath(element);
    const clipPathElemement = clipPath && clipPath.childNodes[0];
    const bbox = clipPathElemement ? clipPathElemement.getBBox() : element.getBBox();
    const boxRatio = bbox.width / bbox.height;
    const imageRatio = replaceImage.width / replaceImage.height;
    const [newWidth, newHeight] = boxRatio > imageRatio
      ? [bbox.width, bbox.width * replaceImage.height / replaceImage.width]
      : [bbox.height * replaceImage.width / replaceImage.height, bbox.height];

    return {
      x: bbox.x + (bbox.width - newWidth) / 2,
      y: bbox.y + (bbox.height - newHeight) / 2,
      width: newWidth,
      height: newHeight
    };
  }
};

VideoSetter.prototype._resizeExternalThumbnail = function (element, data) {
  if (typeof data.source !== 'string') return;

  const url = 'https://www.googleapis.com/youtube/v3/videos?id=' +
    data.source + '&key=' + INKIVE.C.YOUTUBE_KEY +
    '&fields=items(snippet(thumbnails))&part=snippet';

  const image = new Image();
  image.src = data.thumb_src;
  image.onload = _.bind(this._matchBoxToImage, this, element, data, image);

  $(element).addClass('resizing');
  this.trigger('optimize_resolution', element.getAttribute('id'));

  return $.ajax({
    url,
    dataType: 'jsonp',
    success: _.bind(function (data) {
      data = data || {};
      if (data.error) {
        this.trigger('resolution_optimized', element.getAttribute('id'), data);
        return;
      }
      const thumbs = data.items[0].snippet.thumbnails;
      const biggestThumb = thumbs.maxres ||
        thumbs.standard ||
        thumbs.high ||
        thumbs.medium ||
        thumbs.default;

      resizeBiggestCapture.call(this, biggestThumb.url);
    }, this),
    error: function (jqXHR, textStatus, errorThrown) {
      $.post(INKIVE.C.BASE_URL + 'api/errortrack/log', {
        data: '[Youtube Video] ' + textStatus + ' | ' + errorThrown,
        is_critical: true
      });
    }
  });

  function resizeBiggestCapture (src) {
    const params = {
      photo_url: src,
      platform: 'tab'
    };

    const url = INKIVE.C.BASE_URL + 'inkive/resizeexternalsearchphoto';

    $.api(url, 'POST', params, _.bind(function (result) {
      if (result.STATUS === 'success') {
        const imageData = {
          thumb: result.MESSAGE.replace('/tab/', '/thumb/'),
          mobile: result.MESSAGE.replace('/tab/', '/mobile/'),
          tab: result.MESSAGE,
          web: result.MESSAGE.replace('/tab/', '/web/'),
          largeweb: result.MESSAGE.replace('/tab/', '/largeweb/'),
          original: result.MESSAGE.replace('/tab/', '/original/')
        };

        ImagesFactory.addImageData(imageData, ImagesFactory.defaultAmazonDataNames);
      }

      const _onImage = _.bind(this._matchImageToBox, this, element, data);

      (function attemptImageLoad (version) {
        const image = new Image();
        image.src = version || result.MESSAGE;
        image.onload = _.partial(_onImage, image);
        image.onerror = function () {
          setTimeout(_.partial(
            attemptImageLoad,
            result.MESSAGE.replace('/tab/', '/original/')
          ), 1000);
        };
      })();
    }, this));
  }
};

VideoSetter.prototype.updateSize = function (element) {
  const title = $(element).find('title')[0];

  ElementSetter.prototype.updateSize.apply(this, arguments);
  const bbox = svgedit.utilities.getBBox($(element).children('image')[0]);

  this._updatePlayButtonPositioning(element);

  if (title) {
    title.textContent = Math.floor4(bbox.x) +
    ' ' + Math.floor4(bbox.y) +
    ' ' + Math.floor4(bbox.width) +
    ' ' + Math.floor4(bbox.height);
  }
};

VideoSetter.prototype.updateClipPath = function (element, data) {
  const { clip_path: dimensions } = data;

  [element.querySelector('image'), element.querySelector('foreignObject')]
    .filter(Boolean)
    .forEach(target => svgedit.utilities.assignAttributes(target, dimensions));

  this._updatePlayButtonPositioning(element);
};

VideoSetter.prototype._matchImageToBox = function (element, data, image) {
  const bbox = element.getBBox();
  const imageRatio = image.width / image.height;
  const boxRatio = bbox.width / bbox.height;
  let imageElement = $(element).children('image')[0];

  $(element).removeClass('resizing');

  const newSize = getNewSize(imageRatio < boxRatio, bbox, imageRatio);
  convertToLayoutBox.call(this);

  data.thumb_src = image.src;
  this.trigger('resolution_optimized', element.getAttribute('id'), data);

  function convertToLayoutBox (params) {
    const layoutBox = this.canvas.addSvgElementFromJson({
      element: 'rect',
      curStyles: false,
      attr: {
        x: bbox.x,
        y: bbox.y,
        id: this.canvas.getNextId(),
        width: bbox.width,
        height: bbox.height
      }
    });

    $(imageElement).remove();
    imageElement = this.canvas.runExtensions('addLayoutBox', {
      elem: layoutBox,
      clipPathBB: bbox,
      'xlink:href': image.src
    });

    imageElement.setAttribute('width', newSize.width);
    imageElement.setAttribute('height', newSize.height);
    imageElement.setAttribute('x', bbox.x - (newSize.width - bbox.width) / 2);
    imageElement.setAttribute('y', bbox.y - (newSize.height - bbox.height) / 2);

    $(imageElement).addClass('layoutBox').removeClass('element');
    $(element).prepend(imageElement);
  }
};

VideoSetter.prototype._matchBoxToImage = function (element, data, image) {
  const bbox = element.getBBox();
  const imageRatio = image.width / image.height;
  const boxRatio = bbox.width / bbox.height;

  const newSize = getNewSize(imageRatio > boxRatio, bbox, imageRatio);
  this.updateSize(element, { size: newSize });
};

function getNewSize (fillVerticaly, bbox, imageRatio) {
  return fillVerticaly
    ? {
        width: bbox.width,
        height: bbox.width / imageRatio
      }
    : {
        width: bbox.height * imageRatio,
        height: bbox.height
      };
}

VideoSetter.prototype._updatePlayButtonPositioning = function (element) {
  const boxCoordinates = getBoxCoordinates();

  element.querySelector('path').remove();

  if (element.dataset.videoType === 'mp4') {
    this._appendMp4PlayIcon(element, boxCoordinates);

    updateVideoPlayerSize(element);
  } else {
    this._appendYoutubePlayIcon(element, boxCoordinates);
  }

  function getBoxCoordinates () {
    if (!element.hasAttribute('clip-path')) return;

    return svgedit.utilities.getBBox(svgedit.utilities.getClipPath(element));
  }
};

VideoSetter.prototype._appendMp4PlayIcon = function (element, boxCoordinates) {
  const bbox = boxCoordinates || svgedit.utilities.getBBox(element);
  const x = Math.floor4(bbox.x + bbox.width / 2);
  const y = Math.floor4(bbox.y + bbox.height / 2);
  const path = `M ${x},${y} ${x},${y} z`;

  const image = this.canvas.addSvgElementFromJson({
    element: 'path',
    attr: {
      id: this.canvas.getNextId(),
      d: path,
      fill: '#FFFFFF'
    }
  });

  element.appendChild(image);
};

VideoSetter.prototype._appendYoutubePlayIcon = function (element, boxCoordinates) {
  const bbox = boxCoordinates || svgedit.utilities.getBBox(element);

  let x = Math.floor4(bbox.x + bbox.width / 2);
  let y = Math.floor4(bbox.y + bbox.height / 2);
  let size = bbox.width > bbox.height ? bbox.height : bbox.width;
  size *= 0.2;

  x -= size / 4;
  y -= size / 2;

  const image = this.canvas.addSvgElementFromJson({
    element: 'path',
    attr: {
      id: this.canvas.getNextId(),
      d: 'M ' + (size + x) + ',' + (size / 2 + y) + ' ' + x + ',' + (size + y) + ' ' + x + ',' + y + ' z',
      fill: '#FFFFFF'
    }
  });

  element.appendChild(image);
};

VideoSetter.prototype._getYoutubeCode = VideoGetter.prototype._getYoutubeCode;
